export const SET_HAS_EXPERIENCE = 'SET_HAS_EXPERIENCE';

export const SetHasExperience = (value) => {
    return {
        type: SET_HAS_EXPERIENCE,
        payload: {
            value: value
        }
    }
}